import React from "react";

// Official IMMUSKI wordmarks — two variants.
// Use LOGO_BLACK on light backgrounds. Use LOGO_WHITE on dark backgrounds.
// The BLACK variant is served from /public (converted from user-provided PDF).
export const LOGO_BLACK = "/logo-black-1.png";
export const LOGO_WHITE_BG = "/logo-white-bg-1.png";
export const LOGO_CROPPED = "/logo-cropped.webp";
export const LOGO_WHITE = "https://customer-assets-cm19k8pv.emergentagent.net/job_glow-essentials-49/artifacts/rvxnzwby_Immuski%20Logo%20transparent%20White.webp";

export default function Logo({ variant = "on-light", height = 40, className = "" }) {
  const src = variant === "on-dark" ? LOGO_WHITE : LOGO_BLACK;
  return (
    <img
      src={src}
      alt="IMMUSKI"
      style={{ height, width: "auto", display: "block" }}
      className={"select-none " + className}
      data-testid="brand-logo"
    />
  );
}
